import { ActionButtonType } from "@octopusdeploy/design-system-components";
import type { AuditStreamConfigurationResource } from "@octopusdeploy/octopus-server-client";
import { Action, Plan, useAnalyticActionDispatch } from "~/analytics/Analytics";
import { AuditActionWithStatus } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditActionWithStatus";
import { EditAuditStreamDialog } from "~/areas/configuration/components/AuditLayout/AuditStream/EditAuditStreamDialog";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
interface AuditStreamNotConfiguredButtonProps {
    auditStreamConfiguration: AuditStreamConfigurationResource;
    onUpdate: (value: AuditStreamConfigurationResource, message: string) => void;
    isTrial: boolean;
}
export function AuditStreamNotConfiguredButton({ auditStreamConfiguration, onUpdate, isTrial }: AuditStreamNotConfiguredButtonProps) {
    const dispatchAction = useAnalyticActionDispatch();
    const handleClick = () => {
        dispatchAction("Stream Audit Log", { resource: "Audit Stream", action: Action.Add, plan: Plan.Enterprise });
    };
    return (<AuditActionWithStatus status={"inactive"}>
            <OpenDialogButton type={ActionButtonType.Ternary} label="Stream Audit Log" dialogWidth={"1000px"} onClick={handleClick} renderDialog={(renderProps) => <EditAuditStreamDialog auditStreamConfiguration={auditStreamConfiguration} onUpdate={onUpdate} open={renderProps.open} close={() => renderProps.closeDialog()} isTrial={isTrial}/>}/>
        </AuditActionWithStatus>);
}
